/**
 * @generated SignedSource<<8fde339581d1823c9615a3860430cf5d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ScreenersRecruitStatusChoices = "F" | "NS" | "P" | "S" | "%future added value";
export type ScreenersRecruitTypeChoices = "EM" | "HP" | "RO" | "WL" | "YP" | "%future added value";
export type CreateRecruitInput = {
  clientMutationId?: string | null;
  studyId: string;
};
export type RecruitPage_createRecruit_Mutation$variables = {
  input: CreateRecruitInput;
};
export type RecruitPage_createRecruit_Mutation$data = {
  readonly createRecruit: {
    readonly recruitEdge: {
      readonly node: {
        readonly id: string;
        readonly status: ScreenersRecruitStatusChoices;
        readonly type: ScreenersRecruitTypeChoices | null;
      } | null;
    } | null;
  } | null;
};
export type RecruitPage_createRecruit_Mutation = {
  response: RecruitPage_createRecruit_Mutation$data;
  variables: RecruitPage_createRecruit_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateRecruitPayload",
    "kind": "LinkedField",
    "name": "createRecruit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecruitEdge",
        "kind": "LinkedField",
        "name": "recruitEdge",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RecruitNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecruitPage_createRecruit_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecruitPage_createRecruit_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "eea34429b0efe28ea3a9fe5cf022ba05",
    "id": null,
    "metadata": {},
    "name": "RecruitPage_createRecruit_Mutation",
    "operationKind": "mutation",
    "text": "mutation RecruitPage_createRecruit_Mutation(\n  $input: CreateRecruitInput!\n) {\n  createRecruit(input: $input) {\n    recruitEdge {\n      node {\n        id\n        status\n        type\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a4cf560ae3f3730bf230cea7d57e0261";

export default node;
